"use client";

import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";

export function InvalidLengthMaxModal({
  open,
  closeModal,
  audioLengthMinLimitMinutes,
  audioLengthMaxLimitMinutes,
}: {
  open: boolean;
  closeModal: () => void;
  audioLengthMinLimitMinutes: number | null;
  audioLengthMaxLimitMinutes: number;
}) {
  const hasMinLimit = audioLengthMinLimitMinutes !== null;

  let maxLimitText: string;
  if (audioLengthMaxLimitMinutes < 1) {
    const audioLengthMaxLimitSeconds = audioLengthMaxLimitMinutes * 60;
    maxLimitText = `Max audio length: ${audioLengthMaxLimitSeconds} seconds.`;
  } else {
    maxLimitText = `Max audio length: ${audioLengthMaxLimitMinutes} minutes.`;
  }

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Invalid audio length"
      widthMode="normal"
    >
      {hasMinLimit && (
        <NormalText elementType="p">
          Min audio length: {audioLengthMinLimitMinutes} minutes.
        </NormalText>
      )}
      <NormalText elementType="p">{maxLimitText}</NormalText>
    </Modal>
  );
}
